
export const enum AuthType {
  CMS = 'cms', // 内部编剧
  UGC = 'ugc', // 外部编剧
  PIC = 'pic', // 图片书编剧
  PIC_UGC = 'pic+ugc', // 图片书编剧+外部编剧
  ADMIN = 'admin',
}

export const loginPhoneDefault = {
  name: '腾讯网友',
  avatar: 'http://i.gtimg.cn/qqlive/images/20180516/icon120.png',
};

export const loginNovaDefault = {
  name: '梦予用户',
  avatar: 'https://nova.file.video.qpic.cn/uploadFile/1c726328bbb98903ce50754515f0a99a7c11e0c2945360e9a8979055bd5da343.png',
};
